import R from 'ramda';
import { compareJSONObjects } from '../../../../utils';

function saveBlockChange(
  block,
  data,
  propDealChanges,
  updateDealChange,
  createDealChange
) {
  let found = false;
  let changed = false;
  const dealChanges = R.filter(
    (dealChange) =>
      dealChange.user === data.user &&
      dealChange.type === 'change-request-contract-block',
    propDealChanges
  );

  dealChanges.forEach((dealChange) => {
    const changes = JSON.parse(dealChange.changes);
    if (
      changes &&
      changes.contract_block &&
      changes.contract_block.id === block.id
    ) {
      found = true;
      if (
        changes.contract_block.accept !== block.accept ||
        (!block.accept &&
          !compareJSONObjects(changes.contract_block.changes, block.changes)) ||
        (block.accept2 !== undefined &&
          changes.contract_block.accept2 !== block.accept2) ||
        (!block.accept2 &&
          !compareJSONObjects(changes.contract_block.changes, block.changes))
      ) {
        changed = true;
        updateDealChange({ ...dealChange, changes: data.changes });
      }
    }
  });

  if (!found) {
    changed = true;
    createDealChange(data);
  }

  return changed;
}

export default saveBlockChange;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/saveBlockChange.js